import React, {useEffect} from "react";
import {Box, ClickAwayListener, Grid, Link, Typography} from "@mui/material";
import {makeStyles} from "@mui/styles";
import {
    downloadExcelFileWithAnalyticsReportForSelectedFlyer,
    getAnalyticsDataForSelectedFlyer
} from "../../store/actionCreators/analyticsActionCreators";
import {useDispatch} from "react-redux";
import {useTypedSelector} from "../../hooks/useTypeSelector";
import {PageSpinner} from "../../components/com/pagesTab/pagesSpinner/spinner";
import {FlyerDto} from "../../dtos";
import {ReactComponent as DashboardIcon} from "../../assets/analitics_popup/view_dashboard_icon.svg";
import {ReactComponent as DownloadExcelIcon} from "../../assets/analitics_popup/download_ecxel_icon.svg";


const useStyles = makeStyles(() => ({
    analyticsPopup: {
        // position: `absolute`,
        zIndex: 2,
        width: `200px`,
        height: "320px",
        // height: `250px`,
        // top: `calc(100% + 5px)`,
        // right: `0`,
        backgroundColor: `#FFFFFF`,
        border: `1px solid #D3D3D3`,
        borderRadius: `6px`,
        cursor: `default`,
        padding: `12px`
    },
    analyticsCell: {
        backgroundColor: `#B3B3B326`,
        borderRadius: `8px`,
        height: `64px`,
        padding: `12px`
    },
    cellCaption: {
        '&.MuiTypography-root': {
            fontWeight: `400`,
            fontSize: `12px`,
            lineHeight: `14px`,
        }
    },
    cellCount: {
        '&.MuiTypography-root': {
            fontWeight: `700`,
            fontSize: `16px`,
            lineHeight: `25px`,
        }
    }
}))

interface Props {
    setShowAnalyticsPopup: (value: boolean) => void;
    closePopup: VoidFunction;
    flyerData?: FlyerDto | null;
}


export const AnalyticsPopup: React.FC<Props> = ({
                                                    setShowAnalyticsPopup,
                                                    flyerData = null,
                                                    closePopup
                                                }) => {
    const dispatch = useDispatch();
    const classes = useStyles();
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyersData = useTypedSelector((state) => state.flyers);
    const analyticsData = useTypedSelector((state) => state.analyticsData);

    useEffect(() => {
        dispatch(getAnalyticsDataForSelectedFlyer(flyerData ? flyerData.flyRecId! : flyerDetailsState.flyRecId));
    }, []);


    const downloadAnalyticsReport = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        closePopup();
        dispatch(downloadExcelFileWithAnalyticsReportForSelectedFlyer(flyerData ? flyerData.flyRecId! : flyerDetailsState.flyRecId, flyerData ? flyerData.flyDisplayCaption! : flyerDetailsState.flyDisplayCaption));
    }

    return (
        <ClickAwayListener onClickAway={() => {
            closePopup();
        }}>
            <Box className={classes.analyticsPopup}>
                {
                    analyticsData.loading ?
                        <Box sx={{
                            width: `100%`,
                            height: `100%`,
                            alignItems: `center`,
                            justifyContent: `center`,
                            display: `flex`
                        }}>
                            <PageSpinner/>
                        </Box> :
                        <Box sx={{
                            display: `flex`,
                            flexFlow: `column`,
                            height: `100%`
                        }}>
                            <Box px={`12px`}>
                                <Typography
                                    fontWeight={700}
                                    fontSize={`16px`}
                                    lineHeight={`25px`}
                                >
                                    Analytics
                                </Typography>
                            </Box>
                            <Box>
                                <Grid container py={`8px`}>
                                    <Grid item xs={6} px={`12px`}>
                                        <Typography
                                            fontWeight={700}
                                            fontSize={`12px`}
                                            lineHeight={`14px`}
                                        >
                                            Opens
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} px={`12px`}>
                                        <Typography
                                            fontWeight={700}
                                            fontSize={`12px`}
                                            lineHeight={`14px`}
                                        >
                                            Lists
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box>
                                <Grid container columnSpacing={`5px`} rowSpacing={`5px`}>
                                    <Grid item xs={6}>
                                        <Box
                                            className={classes.analyticsCell}
                                        >
                                            <Typography
                                                className={classes.cellCaption}
                                            >
                                                Today
                                            </Typography>
                                            <Typography
                                                className={classes.cellCount}
                                            >
                                                {analyticsData.analyticsData?.todaysImpressions}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            className={classes.analyticsCell}
                                        >
                                            <Typography
                                                className={classes.cellCaption}
                                            >
                                                Today
                                            </Typography>
                                            <Typography
                                                className={classes.cellCount}
                                            >
                                                {analyticsData.analyticsData?.todaysConversions}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            className={classes.analyticsCell}
                                        >
                                            <Typography
                                                className={classes.cellCaption}
                                            >
                                                Total
                                            </Typography>
                                            <Typography
                                                className={classes.cellCount}
                                            >
                                                {analyticsData.analyticsData?.totalImpressions}
                                            </Typography>
                                        </Box>

                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box
                                            className={classes.analyticsCell}
                                        >
                                            <Typography
                                                className={classes.cellCaption}
                                            >
                                                Total
                                            </Typography>
                                            <Typography
                                                className={classes.cellCount}
                                            >
                                                {analyticsData.analyticsData?.totalConversions}
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{
                                flex: `1 1 auto`,
                                display: `flex`,
                                flexFlow: "column",
                                rowGap: "8px",
                                margin: "12px 0"
                            }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                    }}
                                >
                                    <Link
                                        onClick={(e: React.MouseEvent<HTMLElement>) => {
                                            closePopup();
                                        }}
                                        href={flyersData?.analyticsDashboardUrl}
                                        fontSize={`14px`}
                                        lineHeight={`21px`}
                                        rel="noopener noreferrer"
                                        target={"_blank"}
                                        sx={{
                                            columnGap: "8px",
                                            display: "flex",
                                            width: "100%",
                                            alignItems: "center",
                                            textDecoration: `none`,
                                            cursor: `pointer`,
                                            color: "#014780",
                                            padding: "8px",
                                            border: "1px solid #014780",
                                            borderRadius: "6px",
                                            "&:hover": {
                                                color: "#014780",
                                                textDecoration: `none`,
                                            }
                                        }}
                                    >
                                        <DashboardIcon/>
                                        View Dashboard
                                    </Link>
                                </Box>
                                <Box
                                    onClick={downloadAnalyticsReport}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        columnGap: "8px",
                                        cursor: `pointer`,
                                        padding: "8px",
                                        border: "1px solid #014780",
                                        borderRadius: "6px",
                                    }}>
                                    <DownloadExcelIcon/>
                                    <Typography
                                        color={"#014780"}
                                        fontSize={`14px`}
                                        lineHeight={`21px`}
                                    >
                                        Download Excel
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                }
            </Box>
        </ClickAwayListener>
    )
}